module.exports = __webpack_public_path__ + "img/lgo.313975f5.svg";